import { render, staticRenderFns } from "./Tjenester.vue?vue&type=template&id=7147a7a7&scoped=true&"
import script from "./Tjenester.vue?vue&type=script&lang=js&"
export * from "./Tjenester.vue?vue&type=script&lang=js&"
import style0 from "./Tjenester.vue?vue&type=style&index=0&id=7147a7a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7147a7a7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {
  VTab,
  VTabItem,
  VTabs,
})
